import React from "react"
import '../style/common.css'
import './SelectType.css'

import showImgI from '../assets/xxxx/BaoBounty_main_mascot_character_cute_round_steame-1776448209781.png'
import SelectImgI from '../assets/xxxx/BaoBounty_brand_logo_mark_tiny_cute_steamed_bao_b-1776448119303.png'

import SelectView from '../component/SelectView'

import selectPimg from '../assets/xxxx/BaoBounty_recruiter_illustration_cute_bao_bun_mas-1776448106306.png'
import pimg from '../assets/xxxx/BaoBounty_job_seeker_illustration_cute_bao_bun_ma-1776448110005.png'
import {postFormData } from "../network/request"


class SelectType extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            selectStatus : false 
        }

        this.clickTypeAction = this.clickTypeAction.bind(this)
        this.clickWorkAction = this.clickWorkAction.bind(this)
    }


    clickTypeAction(){
        console.log("clickTypeAction")
        this.setState({
            selectStatus : true
        })
    }

    clickWorkAction(){
        console.log("clickWorkAction")
        this.setState({
            selectStatus : false
        })
    }

    clickSelectUserJobType(){
        // 获取用户UserId
        let userInfo = localStorage.getItem("initUser")
        let userJson = JSON.parse(userInfo);
        var userId = userJson["user_id"];

        const formData = new FormData();
         
         formData.append("userId", userId);

         if (this.state.selectStatus) {
             formData.append("jobType", "2");
         }else {
             formData.append("jobType", "1");
         }
 
         postFormData("/fetchUser", formData)
            .then(response => {
                if (response && response["success"] === true) {
                    // 更新本地存储的用户信息
                    userJson["jobType"] = this.state.selectStatus ? 2 : 1
                    localStorage.setItem("initUser", JSON.stringify(userJson));
                    
                    this.props.onClick()
                }
             })
             .catch(error => {
                 console.error("数据提交失败:", error);
                 
             });       
    }


    render(){
        return(
            <div className="SelectTypeV">
                <img src={showImgI} className="showHeadImg"></img>

                <div className="SelectTitleV">
                    <p className="SelectTitleL">Let's get started! Are you:</p>
                </div>

                <div className="selectPersonV">
                    <div style={{width: '20px'}}></div>
                    <SelectView title="Looking for a job" img={pimg} selectStat={!this.state.selectStatus} onClick={this.clickWorkAction}></SelectView>
                    <div style={{width: '10px'}}></div>
                    <SelectView title="Hiring talent" img={selectPimg} selectStat={this.state.selectStatus} onClick={this.clickTypeAction}></SelectView>
                    <div style={{width: '20px'}}></div>
                </div>

                <div className="startQuestionBtn" onClick={this.clickSelectUserJobType.bind(this)}>
                    <p className="startL">Start</p>
                </div>
                
                <div className="selectBgV"></div>
            </div>
        )
    }
}

export default SelectType